import { useEffect, useState } from "react"
import Skeleton from "react-loading-skeleton"
import { useSelector } from "react-redux"
import { Link } from "react-router-dom"

export default function OrderDetails(props){
    const {id}=props

const [order,setOrder]=useState()
let orders=useSelector(state=>state.order.orders)

    useEffect(()=>{

        setOrder(()=>orders.filter(order=>order.id==id))

    },[orders])

    if(!order){
        return <Skeleton count={50} />
    }


    console.log(order)

    return <Link to={`/products/${order[0].product_id}`} >{order[0].title}</Link>
}